
import { FileIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { formatBytes } from "@/lib/utils";

interface FilePreviewProps {
  file: File;
  isUploading: boolean;
  uploadProgress: number;
  onRemove: () => void;
  onUpload: () => void;
}

const FilePreview = ({
  file,
  isUploading,
  uploadProgress,
  onRemove,
  onUpload
}: FilePreviewProps) => {
  return (
    <div className="border rounded-lg p-4">
      <div className="flex items-center space-x-4">
        <div className="h-12 w-12 bg-brand-50 text-brand-600 rounded flex items-center justify-center">
          <FileIcon size={24} />
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm truncate">{file.name}</p>
          <p className="text-xs text-muted-foreground">{formatBytes(file.size)}</p>
        </div>
        
        <Button 
          variant="ghost" 
          size="icon" 
          onClick={onRemove}
          disabled={isUploading}
        >
          <X size={16} />
        </Button>
      </div>
      
      {isUploading ? (
        <div className="mt-4">
          <Progress value={uploadProgress} />
          <p className="text-xs text-muted-foreground mt-1">
            Загружено {uploadProgress}%
          </p>
        </div>
      ) : (
        <Button 
          className="w-full mt-4"
          onClick={onUpload}
        >
          Продолжить
        </Button>
      )}
    </div>
  );
};

export default FilePreview;
